<template>
  <v-container fluid class="pa-0 pb-8">
    <v-container class="container-custom">
      <Breadcrumbs
        :title="$t('modules.portalalumno.procedures.reEnrollmentStatus.breadcrumbs.title')"
        :analytics="{category: 'Tramites', label: 'Rematriculacion Step 1'}"
      ></Breadcrumbs>
      <v-row justify="center">
        <v-col class="viewSpaces" cols="12">
          <template v-if="!loading">
            <Renewal v-if="uploadDocumentation" :type="selectedRenewal" @goBack="onGoBack" :procedure="model.benefit.data.procedure" @uploadDocumentation="documentationFinish"></Renewal>
            <SuccessMessage
              v-if="warningAnexo"
              :title="successMessage.title"
              :type="successMessage.type"
              :actionPrimary="successMessage.actionPrimary"
              :actionSecondary="successMessage.actionSecondary"
            ></SuccessMessage>
            <template class="d-flex align-center justify-center" v-if="!uploadDocumentation && !warningAnexo ">
              <v-row>
                <v-col sm="10" class="card-title-reEnrollment d-flex flex-column align-start mx-auto px-10 py-6 mt-2" :style="`background-image: url('${require('@/assets/images/portalalumno/procedures-header.png')}')`">
                  <div class="d-flex flex-column">
                    <span class="headline white--text" v-if="studentData">{{ `${studentData.student.user.userData.name},` }}</span>
                    <span class="white--text caption">{{ $t('modules.portalalumno.procedures.reEnrollmentStatus.subtitle', { period }) }}</span>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col sm="10" class="d-flex flex-column mx-auto" v-if="showItem">
                  <p class="subtitle-2 mt-3 font-weight-light">{{ $t('modules.portalalumno.procedures.reEnrollmentStatus.scholarshipWarning') }}</p>
                  <v-row align="stretch">
                    <v-col cols="6" v-if="item">
                      <InfoCard :disabled="item.disabled" :item="item"/>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="10" offset="1" class="d-flex align-center justify-start mt-5">
                  <Button
                    :text="(needGenerateMatricula) ? $t('modules.portalalumno.procedures.reEnrollmentStatus.startReEnrollment') : $t('modules.portalalumno.procedures.reEnrollmentStatus.startArancel')"
                    primary
                    @clicked=" needGenerateMatricula ? goToMatricula() : goToAnexo()"
                  ></Button>
                </v-col>
              </v-row>
            </template>
          </template>
          <v-row v-else>
            <v-col sm="12" class="d-flex align-center justify-center py-10">
              <v-progress-circular block indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import InfoCard from '../../Components/InfoCard/InfoCard';
import Renewal from './Renewal'
import { $studentProcessing , $terms, $studentAccount, $students } from '../../services';
import Button from '@/components/Button/Button'
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage'
import { mapGetters } from 'vuex'

export default {
  name: 'ReEnrollment',
  components: {
    Breadcrumbs,
    InfoCard,
    Renewal,
    Button,
    SuccessMessage
  },
  data () { 
    return {
      period: '',
      item: null,
      reEnrollmentCase: 'benefit',
      reEnrollmentOptions: ['prontoPago','benefit','scholarship'],
      needGenerateMatricula: false,
      uploadDocumentation: false,
      loading: false,
      warningAnexo: false,
      successMessage: {
        title: null,
        type: null,
        actionPrimary: null,
        actionSecondary: null,
      },
      model: { 
        prontoPago: { 
          dataToShow: [],
          dataNeeded: [],
          data: {
            warning: [],
          }
        },
        scholarship: {
          dataToShow: ['scholarshipAlert',],
          dataNeeded: [],
          data: {
            warning: ['R'],
            state: null,
            scholarshipAlert: 'Para poder aspirar a la renovación de una beca, deberás tener un promedio ponderado igual o mayor a cinco punto cinco (5.5), y no haber tenido asignaturas reprobadas.'
          }
        },
        benefit: {
          dataToShow: [],
          dataNeeded: ['state'],
          data: {
            warning: ['R','P','W'],
            state: null,
            procedure: null,
            benefitStateBlocked: [],
            benefitCardBlocked: ['S','D','R'],
          }
        }
      },
  }},
  methods: {
    async initialize () {  
      this.checkCorrectFlow()
      this.getCurrentPeriod()
      await this.defineCase()

      // Get item to show, depending on the case.
      this.item = await this.getItem()
    },
    goToMatricula() {
      // this.$trackEvent('Tramites', 'Comenzar', 'Rematriculacion Step 1')
      if(this.$isIPP) {
        this.$trackEvent('Tramites', 'Clk_ComRemat_Tram', 'Rematricula');
      }
      // Redirect to re-enrollment view.
      this.$router.push({name: 'Rematrícula'})
    },
    goToAnexo() {
      if (this.showWarning){
        const option = this.reEnrollmentCase === 'benefit' ? 'convenio' : 'beca'
        const approve = this.reEnrollmentCase === 'benefit' ? 'aprobado' : 'aprobada'

        this.successMessage.type = 'warning'
        this.successMessage.title = `Si aceptas el anexo sin que tu ${option} haya sido ${approve}, perderás el descuento del mismo sobre tu arancel.`;
        this.successMessage.actionSecondary = { text: this.$t('actions.cancel'), callback: () => {this.warningAnexo = false} }
        this.successMessage.actionPrimary = { text: this.$t('modules.portalalumno.procedures.reEnrollmentStatus.startArancel'), callback: () => {this.$router.push({name: 'anexo'})} }
        this.warningAnexo = true;
      } else {
        const approved = this.model[this.reEnrollmentCase].data.state === 'S';
        this.$router.push({name: 'anexo', params: {approved}})
      }
    },
    onGoBack(){
      this.uploadDocumentation = false;
    },
    async getCurrentPeriod(){
      const periodData = await $terms.currentPeriod({ params: { reenrollment: true }})
      this.period = periodData.data.content[0].description
    },
    async documentationFinish(){
      this.item = await this.getItem()
      this.uploadDocumentation = false
    },
    async checkCorrectFlow(){
      this.loading = true;
      const MATRICULAID = this.$sisConstants('modules.products.matricula')
      const ARANCELID = this.$sisConstants('modules.products.arancel')
      const reEnrollmentOptions = await $studentAccount.find(`reEnrollmentStatus/${this.studentRegister}`)
      let optionStatus = null
      
      if (reEnrollmentOptions.data.tariff) {
        const tariffData = await $studentAccount.find(`paymentStatus/${this.studentRegister}?idProduct=${ARANCELID}`)
        optionStatus = tariffData.data
      } else if (reEnrollmentOptions.data.reEnrollment) {
        const reEnrollmentData = await $studentAccount.find(`paymentStatus/${this.studentRegister}?idProduct=${MATRICULAID}`)
        optionStatus = reEnrollmentData.data
      }
      const { status, generateTicket } = optionStatus
      const { reEnrollment, tariff } = reEnrollmentOptions.data

      // Tiene que pagar matricula, no generó ticket por ende no pagó
      this.needGenerateMatricula = reEnrollment && tariff && !generateTicket && !status; 
      this.loading = false;
    },
    defineCase(){
      // Sets the payment case presented by the user.
      if (this.studentData.benefit) this.reEnrollmentCase = 'benefit'
      else if (this.studentData.scholarship) this.reEnrollmentCase = 'scholarship'
      else this.reEnrollmentCase = 'prontoPago'
    },
    async getBenefitState() {
      try{
        const state = await $studentProcessing.find(`benefitStatus?idStudentCareer=${this.studentRegister}`)
        const status = state.data.status.value
        
        if (status == 91) this.model.benefit.data.state = 'R'
        else if (status == 92) this.model.benefit.data.state = 'D'
        else if (status == 93) this.model.benefit.data.state = 'S'
        else if (status == 113) {
          this.model.benefit.data.procedure = state.data.id;
          this.model.benefit.data.state = 'W'
        }

      } catch {
        this.model.benefit.data.state = 'P'
      }
    },
    async getScholarshipState() {
      try{
        const state = await $students.find(`renewScholarshipStatus/${this.studentRegister}`)
        const status = state.data.renewScholarship.value

        if (status == 77) this.model.scholarship.data.state = 'S'
        else if (status == 78) this.model.scholarship.data.state = 'R'
        else if (status == 150) this.model.scholarship.data.state = 'D'
      }catch{
        this.model.scholarship.data.state = 'D'
      }
    },
    async getItem(){
      let item
      let cardBlocked
      let cardStatus

      if (this.reEnrollmentCase == 'benefit') {
        await this.getBenefitState()
        cardStatus = this.model.benefit.data.state;
        cardBlocked = this.model.benefit.data.benefitCardBlocked;
        item = {
          title: this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardBenefit.title'),
          documentation: [this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardBenefit.description')],
          warning: this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardBenefit.warning'),
          disabled: cardBlocked.includes(cardStatus),
          status: cardStatus, // S o R o D o P
          action: {
            text: cardBlocked.includes(cardStatus) ? '' : cardStatus === 'W' ? this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardBenefit.actionWarningTitle') : this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardBenefit.actionTitle'),
            disabled: cardBlocked.includes(cardStatus),
            callback: () => {this.selectedRenewal = 'benefitRenewal'; this.uploadDocumentation = true}
          }
        }
      } else if (this.reEnrollmentCase == 'scholarship') {
        await this.getScholarshipState()
        item = {
          title: this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardScholarship.title'),
          documentation: [this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardScholarship.description')],
          status: this.model.scholarship.data.state, // S o R scholarship
          warning: this.$t('modules.portalalumno.procedures.reEnrollmentStatus.cardScholarship.warning'),
          disabled: false,
          action: {
            text: '',
            disabled: false,
            callback() {}
          }
        }
      }

      return item
    },

  },
  computed: {
    reEnrollmentBlocked() {
      return (this.reEnrollmentCase === 'benefit' && this.model.benefit.data.benefitStateBlocked.includes(this.model.benefit.data.state))
    },
    showItem() {
      if(this.needGenerateMatricula) return false
      else return this.reEnrollmentCase !== 'prontoPago'
    },
    showWarning() {
      const currentCase = this.model[this.reEnrollmentCase].data
      return currentCase.warning.includes(currentCase.state)
    },
    disabledAnexo() {
      return !this.needGenerateMatricula && this.showWarning && this.reEnrollmentCase === 'benefit'
    },
    ...mapGetters({
      studentRegister: 'commons/getStudentActualRegister',
      studentData: 'commons/getStudentData',
    }),
  },
  mounted () {
    this.initialize()
  }
}
</script>

<style lang="sass" scoped>
  .card-title-reEnrollment
    background-size: cover
    background-position-x: 36%
</style>